import { Alert, Box } from '@pinchenterprisesnpm/friday-ui'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { DaysListItem } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/components/days-list-item/days-list-item'
import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import { ShiftPostStep } from '@src/features/shift-post-v2/steps/steps.types'
import { SHIFT_TYPE } from '@src/models/Shift'
import { connect, FormikProps } from 'formik'
import { IBusinessEntity } from '@src/models/BusinessEntity'
import { STARTING_DAY_ALERT_MESSAGE } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils/constants'
import { checkIfBusinessRequiresNextWorkingDaySelection } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'

interface IIndividualDaysListProps {
  formik?: FormikProps<IScheduleSectionFormValues>
  sourcePage: ShiftPostPage
  sourceStep: ShiftPostStep
  isEditable?: boolean
  businessEntity?: IBusinessEntity
}

export const IndividualDaysList = connect<IIndividualDaysListProps>(
  ({ formik, sourcePage, sourceStep, isEditable = true, businessEntity }) => {
    const { errors, values } = formik

    const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM

    const hasNextWorkingDaySelected = values.days.some((day) => day.starting_day && day.working)

    const minDays = isConfirmStep ? 0 : 1

    const showSingleDayShifts =
      values.type === SHIFT_TYPE.SINGLEDAY &&
      sourcePage !== ShiftPostPage.EDIT_SHIFT &&
      values.single_day_shifts.length > minDays

    const showEditSingleDayShift =
      values.type === SHIFT_TYPE.SINGLEDAY &&
      sourcePage === ShiftPostPage.EDIT_SHIFT &&
      !!values.single_day_date &&
      isConfirmStep

    return (
      <Box mt='md'>
        {showEditSingleDayShift && (
          <DaysListItem
            singleDayDate={values.single_day_date}
            isEditable={isEditable}
            businessEntity={businessEntity}
          />
        )}

        {/* Single day shifts */}
        {showSingleDayShifts && (
          <>
            {errors.single_day_shifts && Array.isArray(errors.single_day_shifts) && (
              <Alert
                message='One or more selected single day shifts have an invalid Hourly Pay Rate.'
                type='danger'
              />
            )}

            {values.single_day_shifts.map((day) => (
              <DaysListItem
                key={day.id}
                day={day}
                isEditable={isEditable}
                businessEntity={businessEntity}
              />
            ))}
          </>
        )}

        {/* Multiday shift */}
        {values.type === SHIFT_TYPE.MULTIDAY && (
          <>
            {errors.days && Array.isArray(errors.days) && (
              <Alert
                message='One or more selected days have an invalid Hourly Pay Rate.'
                type='danger'
              />
            )}
            {businessEntity &&
            checkIfBusinessRequiresNextWorkingDaySelection(businessEntity) &&
            !hasNextWorkingDaySelected &&
            !isConfirmStep ? (
              <Alert message={STARTING_DAY_ALERT_MESSAGE} type='primary' />
            ) : null}

            {values.days.length > minDays &&
              values.days.map((day) => (
                <DaysListItem
                  key={day.id}
                  day={day}
                  isEditable={isEditable}
                  businessEntity={businessEntity}
                />
              ))}
          </>
        )}
      </Box>
    )
  }
)
